import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import { BaseStateService } from '../../base-state.service';

@Component({
  selector: 'help-tooltip-button',
  templateUrl: './help-tooltip-button.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpTooltipButtonComponent {
  @Input() forceVisible: boolean = false;
  @Input() tip: string;

  constructor(public stateService: BaseStateService) {
  }

}
